<template>
  <div class="loading-components">
    <ContentNotify />
    <Loading />
    <CurrentPopup />
    <CurrentActionSheet />
  </div>
</template>

<script>
import ContentNotify from '$superAppUser/components/content-notify';
import Loading from '$superAppUser/components/loading';
import CurrentPopup from '$superAppUser/components/current-popup';
import CurrentActionSheet from '$superAppUser/components/current-action-sheet';
export default {
  components: { ContentNotify, Loading, CurrentPopup, CurrentActionSheet }
}
</script>